module.exports = __webpack_public_path__ + "img/peacock.be5030ca.webp";